import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

interface Column {
  key: string;
  header: string;
}

@Component({
  selector: 'zikatagov-data-table',
  template: `
    <div class="mb-3 d-flex justify-content-between align-items-center">
      <div>
        <label for="pageSize" class="me-2">Page Size:</label>
        <select
          id="pageSize"
          class="form-select form-select-sm d-inline-block w-auto"
        >
          <option>10</option>
          <option>25</option>
          <option>50</option>
        </select>
      </div>
      <div>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Search..."
        />
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th *ngFor="let col of columns">{{ col.header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data">
          <td *ngFor="let col of columns">{{ row[col.key] }}</td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center">
      <div>Showing 1-10 of {{ data.length }}</div>
      <nav>
        <ul class="pagination">
          <li class="page-item"><a class="page-link" href="#">Previous</a></li>
          <li class="page-item"><a class="page-link" href="#">1</a></li>
          <li class="page-item"><a class="page-link" href="#">2</a></li>
          <li class="page-item"><a class="page-link" href="#">3</a></li>
          <li class="page-item"><a class="page-link" href="#">Next</a></li>
        </ul>
      </nav>
    </div>
  `,
  standalone: true,
  imports: [CommonModule],
})
export class ZikataDataTableComponent {
  @Input() columns: Column[] = [];
  @Input() data: any[] = [];
}
